import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import { Modal, Button, Select, MenuItem, CardMedia, Input, } from "@mui/material";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddVehicleType({
  open,
  onClose,
  setOpen,
}: ModalProps) {

  const [selectedCategories, setSelectedCategories] = useState<string[]>(["default"]);
  const categories = ["Car", "Bike", "Bicycle", "Caravan", "Trucks", "Heavy Equipment", "Spare Parts", "Car Accessories"];
  const handleCategoryChange = (event: any) => {
    const value = event.target.value as string[];
    if (value.length > 1 && value.includes("default")) {
      setSelectedCategories(value.filter(v => v !== "default"));
    } else {
      setSelectedCategories(value);
    }
  };

  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Vehicle Type</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">
            <div className="control_group w_50">
              <label htmlFor="upload-category-image">
                Upload Image<span className="req">*</span>
              </label>

              {image ? (
                <div className="upload_image no_radius">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="Category" />
                    </figure>
                    <CloseIcon
                      className="remove_img"
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label
                  className="upload_image no_radius"
                  htmlFor="upload-category-image"
                >
                  <Input
                    sx={{ display: "none" }}
                    id="upload-category-image"
                    type="file"
                    inputProps={{ accept: "image/png,image/jpeg" }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = event.target.files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/placeholder.png"
                        alt="Upload"
                      />
                      <span className="upload_img_icon">
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            <div className="control_group">
              <label htmlFor="vehicle-type-name">Vehicle Type Name</label>
              <TextField
                id="vehicle-type-name"
                placeholder="Enter Name"
                fullWidth
                hiddenLabel
              />
            </div>

            <div className="control_group">
              <label htmlFor="Category">Category</label>
              <Select
                multiple
                fullWidth
                hiddenLabel
                value={selectedCategories}
                onChange={handleCategoryChange}
                renderValue={(selected) =>
                  (selected as string[])
                    .filter(v => v !== "default")
                    .join(", ") || "Select Categories"
                }
              >
                <MenuItem value={"default"} disabled>Select Categories</MenuItem>
                {categories.map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
